import {
  GET_PRODUCT_LIST,
  GET_PRODUCT_LIST_SUCCESS,
  GET_PRODUCT_LIST_FAILURE,
} from 'store/productList/productListAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getProductListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRODUCT_LIST:
      return { ...state, loading: true };
    case GET_PRODUCT_LIST_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_PRODUCT_LIST_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getProductListReducer;
